module.exports = __webpack_public_path__ + "static/img/box-border.82c43307.png";